import React from 'react';
import { useSelector } from 'react-redux';
import { beatWaveListSelector } from '../../wave/selectors/wave.selectors';
import { isWaveManual } from '../../wave/utils/wave.util';
import { ManualDelineationBar } from './ManualDelineationBar';

export const ManualQrsBar: React.FC = () => {
  const waves = useSelector(beatWaveListSelector);
  const displayedWaves = waves.filter((wave) => isWaveManual(wave));

  return <ManualDelineationBar waves={displayedWaves} />;
};
